import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo_interno.jpg'
import _imports_1 from '@/assets/img/correctAnswerIcon.svg'


const _withScopeId = n => (_pushScopeId("data-v-c86ccf68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo w-75 mb-5"
}, null, -1))
const _hoisted_3 = { class: "text-center pt-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "icon"
}, null, -1))
const _hoisted_5 = { class: "w-100 mt-5 pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_localized_text, {
        localizedKey: "app_Congratulazioni!",
        text: "Congratulazioni!",
        class: "fs_27 white d-block ln_21 text-uppercase mt-3"
      }),
      _createVNode(_component_localized_text, {
        localizedKey: "app_HaiDirittoARitirareQuestoProdotto",
        text: "Hai diritto a ritirare questo prodotto",
        class: "fs_24 white ln_21 mt-3 d-block"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "secondaryButton w-75 mx-auto mb-3",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.callback()))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_Chiudi",
          text: "Chiudi"
        })
      ]),
      _createElementVNode("button", {
        class: "primaryButton w-75 mx-auto",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.homeCallback()))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_Home",
          text: "Home"
        })
      ])
    ])
  ]))
}